//////////////////////////////////////////////////////////   
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO IMAGEM DE LOGO                         //   
//                                                      //   
//  FUNCIONALIDADE: PERFUMARIA                          //    
//                                                      //   
//////////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/continuar_comprando.js                  //
//      frontend/src/components/franqueado.js                           //
//      frontend/src/components/header.js                               //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import logo from "../../assets/images/logo.png"
import '../../assets/css/local/header.css';

function Logo() {
    const handleLogoClick = () => {
        window.location.href = '/';
    };

    return (
        <div className="col-xl-2 col-md-3 col-4 header-size">
            <img 
                alt='logo' 
                src={logo} 
                className="logo my-1" 
                onClick={handleLogoClick}
                style={{cursor: 'pointer'}}
            />
        </div>
    );
}

  export default Logo;
  